export const recordSearchDateRangeRelativeValues = [
  '15m',
  '60m',
  '3h',
  '12h',
  '24h',
  'today',
  'yesterday',
  '3d',
  '7d',
  'thisweek',
  'prevweek',
  '14d',
  '30d',
  '60d',
  '90d',
  'thismonth',
  'prevmonth',
];

export type RecordSearchDateRangeRelativeValue =
  (typeof recordSearchDateRangeRelativeValues)[number];

export type RecordSearchDateRangeValue =
  | RecordSearchDateRangeRelativeValue
  | [Date, Date];
